import { TEAM_DISCUSSION } from '../../constants';

const initialState = {
  data: [],
  loading: true,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case TEAM_DISCUSSION.LOAD:
      return {
        ...state,
        loading: true
      };
    case TEAM_DISCUSSION.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case TEAM_DISCUSSION.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
